import React from "react";
import { useNavigate } from "react-router-dom";
import Navigation from "../components/Navigation";

const BillingCancel: React.FC = () => {
  const navigate = useNavigate();

  return (
    <>
      <Navigation />
      <div className="min-h-screen bg-[#0a0b0f] bg-grid-pattern relative overflow-hidden flex items-center justify-center px-4">
        <div className="absolute inset-0 bg-radial-gradient pointer-events-none" />

        <div className="relative w-full max-w-md text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-zinc-700/50 border border-zinc-600/30 mb-6">
            <svg className="w-8 h-8 text-zinc-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>

          <h1 className="text-3xl font-bold text-zinc-100 mb-3">Checkout Canceled</h1>
          <p className="text-zinc-400 mb-8">
            Your checkout was canceled. No charges were made.
          </p>

          <div className="space-y-3">
            <button
              onClick={() => navigate("/pricing")}
              className="btn-primary w-full py-3 rounded-xl text-sm font-semibold"
            >
              Back to Pricing
            </button>
            <button
              onClick={() => navigate("/uploads")}
              className="btn-secondary w-full py-3 rounded-xl text-sm font-medium"
            >
              Go to Dashboard
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default BillingCancel;
